import {
  EmptyActivitiesError,
  LessonNotPublishedError,
  ValidationError,
} from '../useContPedStatus';
import EmptyActivitiesFeedback from './EmptyActivitiesFeedback';
import LessonNotPublishedFeedback from './LessonNotPublishedFeedback';

export type ValidationErrorProps<T> = {
  error: T;
  onClose: () => void;
};

export default function ValidationErrorHandler({
  error,
  onClose,
}: ValidationErrorProps<ValidationError | null>) {
  if (!error) return null;

  if (error instanceof LessonNotPublishedError)
    return <LessonNotPublishedFeedback error={error} onClose={onClose} />;

  if (error instanceof EmptyActivitiesError)
    return <EmptyActivitiesFeedback error={error} onClose={onClose} />;

  return null;
}
